import { TimeUtils as NewTimeUtils, DurationConverter as NewDurationConverter } from '@colonist/utils';
(function(TimeUtils) {
    TimeUtils.MILLISECONDS = 1000;
    TimeUtils.SECONDS_IN_MINUTE = 60;
    TimeUtils.SECONDS_IN_HOUR = 3600;
    TimeUtils.MINUTES_IN_HOUR = 60;
    TimeUtils.HOURS_IN_DAY = 24;
    TimeUtils.DAYS_IN_WEEK = 7;
    TimeUtils.DAYS_IN_MONTH = 30;
    TimeUtils.MONTHS_IN_YEAR = 12;
    function isDatePassed(stringDate) {
        return NewTimeUtils.isDatePassed(stringDate);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.isDatePassed = isDatePassed;
    function millisecondsLeftInUTCDay(today) {
        return NewTimeUtils.millisecondsLeftInUTCDay(today);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.millisecondsLeftInUTCDay = millisecondsLeftInUTCDay;
    function getDate(theDate) {
        return NewTimeUtils.getDate(theDate);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getDate = getDate;
    function getDateTime(theDate) {
        return NewTimeUtils.getDateTime(theDate);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getDateTime = getDateTime;
    function getHoursAgoInTimestampFormat(hour) {
        return NewTimeUtils.getHoursAgoInTimestampFormat(hour);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getHoursAgoInTimestampFormat = getHoursAgoInTimestampFormat;
    function convertTimestampToDateTimeText(time) {
        return NewTimeUtils.convertTimestampToDateTimeText(time);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.convertTimestampToDateTimeText = convertTimestampToDateTimeText;
    function timeToString(time) {
        return NewTimeUtils.timeToString(time);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.timeToString = timeToString;
    function timePadding(time) {
        return NewTimeUtils.timePadding(time);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.timePadding = timePadding;
    function getUTCTimeString(time) {
        return NewTimeUtils.getUTCTimeString(time);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getUTCTimeString = getUTCTimeString;
    function minutesPassedSince(time) {
        return NewTimeUtils.minutesPassedSince(time);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.minutesPassedSince = minutesPassedSince;
    function millisecondsPassedSince(time) {
        return NewTimeUtils.millisecondsPassedSince(time);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.millisecondsPassedSince = millisecondsPassedSince;
    function isThisLastMonth(time, from = Date.now()) {
        return NewTimeUtils.isThisLastMonth(time, from);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.isThisLastMonth = isThisLastMonth;
    function isThisLastYear(time, from = Date.now()) {
        return NewTimeUtils.isThisLastYear(time, from);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.isThisLastYear = isThisLastYear;
    function yesterdayDate() {
        return NewTimeUtils.yesterdayDate();
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.yesterdayDate = yesterdayDate;
    function getWeekNumber(milliseconds) {
        return NewTimeUtils.getWeekNumber(milliseconds);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getWeekNumber = getWeekNumber;
    function getDaysHoursMinutesBetweenDates(futureDate, pastDate) {
        return NewTimeUtils.getDaysHoursMinutesBetweenDates(futureDate, pastDate);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getDaysHoursMinutesBetweenDates = getDaysHoursMinutesBetweenDates;
    function getDaysHoursMinutesBetweenDatesString(futureDate, pastDate) {
        return NewTimeUtils.getDaysHoursMinutesBetweenDatesString(futureDate, pastDate);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getDaysHoursMinutesBetweenDatesString = getDaysHoursMinutesBetweenDatesString;
    function getOneWeekInThePast() {
        return NewTimeUtils.getOneWeekInThePast();
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getOneWeekInThePast = getOneWeekInThePast;
    function getOneWeekInTheFuture() {
        return NewTimeUtils.getOneWeekInTheFuture();
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.getOneWeekInTheFuture = getOneWeekInTheFuture;
    function adjustDateByDays(days, date = new Date()) {
        return NewTimeUtils.adjustDateByDays(days, date);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.adjustDateByDays = adjustDateByDays;
    function formatSecondsToElapsedString(seconds) {
        return NewTimeUtils.formatSecondsToElapsedString(seconds);
    }
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */ TimeUtils.formatSecondsToElapsedString = formatSecondsToElapsedString;
})(TimeUtils || (TimeUtils = {}));
(function(DurationConverter) {
    function secondsAsMilliseconds(seconds) {
        return NewDurationConverter.secondsAsMilliseconds(seconds);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.secondsAsMilliseconds = secondsAsMilliseconds;
    function minutesAsMilliseconds(minutes) {
        return NewDurationConverter.minutesAsMilliseconds(minutes);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.minutesAsMilliseconds = minutesAsMilliseconds;
    function hoursAsMilliseconds(hours) {
        return NewDurationConverter.hoursAsMilliseconds(hours);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.hoursAsMilliseconds = hoursAsMilliseconds;
    function daysAsMilliseconds(days) {
        return NewDurationConverter.daysAsMilliseconds(days);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.daysAsMilliseconds = daysAsMilliseconds;
    function weeksAsMilliseconds(weeks) {
        return NewDurationConverter.weeksAsMilliseconds(weeks);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.weeksAsMilliseconds = weeksAsMilliseconds;
    function minutesAsSeconds(minutes) {
        return NewDurationConverter.minutesAsSeconds(minutes);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.minutesAsSeconds = minutesAsSeconds;
    function hoursAsSeconds(hours) {
        return NewDurationConverter.hoursAsSeconds(hours);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.hoursAsSeconds = hoursAsSeconds;
    function daysAsSeconds(days) {
        return NewDurationConverter.daysAsSeconds(days);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.daysAsSeconds = daysAsSeconds;
    function weeksAsSeconds(weeks) {
        return NewDurationConverter.weeksAsSeconds(weeks);
    }
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */ DurationConverter.weeksAsSeconds = weeksAsSeconds;
})(DurationConverter || (DurationConverter = {}));
export var TimeUtils, DurationConverter;
